module.exports = __webpack_public_path__ + "static/media/sort-numeric-down-alt.d29af6cb.svg";